/**
 *
 * This is a source helper to transform printed data to js format.
 *
 */

const sourceFromWeb = false;
let allCalendarItems = null;

/**
 *
 * Reads the  from the DOM and creates a list of them.
 *
 */
function dataExtractDOM() {
  const calendarItems = [];

  $(".js-availability-item").each(function(i, element) {
    const dateItem = $(element);
    const date = new Date(dateItem.data("date"));
    const color = dateItem.data("color");
    const tooltip = dateItem.data("tooltip");
    const editable = dateItem.data("editable");
    const available = dateItem.data("available");

    const item = {
      date,
      color,
      tooltip,
      editable,
      available
    };

    calendarItems.push(item);
  });

  return calendarItems;
}

/**
 *
 * Reads the data from the web end point.
 *
 */
function dataExtractWeb() {
  // TODO add implementation.
}

/**
 *
 * A wrapper method that gets the items inside
 *
 */
function getItems(transformPlugin) {
  if (allCalendarItems == null) {
    allCalendarItems = sourceFromWeb ? dataExtractWeb() : dataExtractDOM();
  }

  if (transformPlugin) {
    return transformPlugin(allCalendarItems);
  } else {
    return allCalendarItems;
  }
}

/**
 *
 * Filter the data using a function.
 *
 * @param {function} filterFunction the function to run against the data.
 * @param {string} filterField If defined, will return only that field.
 */
function getFilteredItems(filterFunction, filterField) {
  const items = getItems(null);
  const filtered = items.filter(filterFunction);

  if (filterField) {
    const singleFieldItems = filtered.map(item => {
      return item[filterField];
    });

    return singleFieldItems;
  } else {
    return filtered;
  }
}

module.exports = {
  getItems,
  getFilteredItems
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-availability-calendar/source-booking-availability.js